<template>
  <div class="upload-heading">
    <input
      style="display: none"
      type="file"
      @change="onFileSelected"
      ref="fileInput"
      multiple
    />
    <label
      class="col-form-label col-form-label-lg"
      id="lbl-file"
      v-if="showLabel"
      @click="$refs.fileInput.click()"
      >Dodajte datoteku</label
    >
    <!-- <i class="fas fa-file-upload" id="upload-icon" @click="$refs.fileInput.click()"></i> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      selectedFile: null
    };
  },
  props: {
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions('modal', ['showFailModal']),
    openFileSelect() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      // validate file size
      for (let file of event.target.files) {
        if (file.size > 5122059) {
          this.showFailModal('Fajl ne može biti veći od 5MB');
          return;
        }
      }

      this.selectedFiles = event.target.files;
      let fileBuffer = [];
      Array.prototype.push.apply(fileBuffer, this.selectedFiles);
      this.$emit('files-selected', fileBuffer);
    }
  }
};
</script>

<style lang="scss">
#upload-icon {
  padding-top: calc(0.5rem + 1px);
  margin-left: 10px;
  /*padding-bottom: calc(0.5rem + 1px);*/
  font-size: 1.25rem;
  line-height: 1.5;
}

.upload-heading:hover {
  #lbl-file {
    cursor: pointer;
  }
  cursor: pointer;
  color: var(--primary-color);
  transition: color 0.25s;
}

.upload-heading {
  display: inline-flex;
}
</style>
